// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-popup-source-documents-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.5rem 0;
}

.dialog-popup-source-documents-section-label {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.dialog-popup-source-documents-section-title {
  font-size: var(--ui-font-md);
  font-weight: 600;
  color: #374151;
}

.dialog-popup-source-documents-section-description {
  font-size: var(--ui-font-sm);
  color: #6b7280;
  line-height: 1.4;
}

.dialog-popup-source-documents-section-description-link {
  color: var(--primary-color);
  font-weight: 600;
  text-decoration: none;
}

.dialog-popup-source-documents-section-description-link:hover {
  text-decoration: underline;
}

.dialog-popup-source-documents-section-description-link-disabled {
  color: #94a3b8;
  cursor: default;
  text-decoration: none;
}

.dialog-popup-source-documents-section-description-tag {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.dialog-popup-source-documents-section-description-tag.clamped {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.dialog-popup-source-documents-section-description-tag.expanded {
  display: block;
}

.dialog-popup-source-documents-section-description-toggle {
  width: fit-content;
  padding: 0;
  margin: -0.05rem 0 0;
  border: none;
  background: transparent;
  font-size: var(--ui-font-sm);
  font-weight: 600;
  color: var(--primary-color);
  cursor: pointer;
}

.dialog-popup-source-documents-section-description-toggle:hover {
  text-decoration: underline;
}

.dialog-popup-source-documents-sources {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}

.dialog-popup-source-documents-source-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.2s ease;
}

.dialog-popup-source-documents-source-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.dialog-popup-source-documents-source-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.875rem;
  gap: 0.625rem;
}

.dialog-popup-source-documents-source-info {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  flex: 1;
  min-width: 0;
}

.dialog-popup-source-documents-source-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: #e0e7ff;
  color: #3730a3;
  border-radius: 8px;
  flex-shrink: 0;
}

.dialog-popup-source-documents-source-icon-file-type {
  background: transparent;
  color: inherit;
}

.dialog-popup-source-documents-source-icon-image {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.dialog-popup-source-documents-source-details {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.dialog-popup-source-documents-source-name {
  font-size: var(--ui-font-sm-plus);
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 0.125rem;
  word-break: break-all;
  line-height: 1.35;
}

.dialog-popup-source-documents-source-preview {
  font-size: var(--ui-font-xs);
  color: #64748b;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.dialog-popup-source-documents-source-actions {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex-shrink: 0;
}

.dialog-popup-source-documents-source-action {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: #64748b;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dialog-popup-source-documents-source-action:hover {
  background: #e2e8f0;
  color: #374151;
}

.dialog-popup-source-documents-source-content {
  border-top: 1px solid #e2e8f0;
  background: white;
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    max-height: 0;
  }
  to {
    opacity: 1;
    max-height: 300px;
  }
}

.dialog-popup-source-documents-source-text {
  padding: 1rem;
  margin: 0;
  font-family: "SF Mono", "Monaco", "Inconsolata", "Roboto Mono", "Consolas", monospace;
  font-size: var(--ui-font-sm);
  line-height: 1.5;
  color: #374151;
  white-space: pre-wrap;
  word-wrap: break-word;
  background: none;
  border: none;
  max-height: 300px;
  overflow-y: auto;
}

.dialog-popup-source-documents-source-text::-webkit-scrollbar {
  width: 6px;
}

.dialog-popup-source-documents-source-text::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.dialog-popup-source-documents-source-text::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.dialog-popup-source-documents-source-text::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

@media (max-width: 550px) {
  .dialog-popup-source-documents-source-header {
    padding: 0.75rem;
    gap: 0.5rem;
  }

  .dialog-popup-source-documents-source-info {
    gap: 0.5rem;
  }

  .dialog-popup-source-documents-source-icon {
    width: 24px;
    height: 24px;
  }

  .dialog-popup-source-documents-source-icon-image {
    width: 18px;
    height: 18px;
  }

  .dialog-popup-source-documents-source-name {
    font-size: var(--ui-font-sm);
  }

  .dialog-popup-source-documents-source-preview {
    font-size: var(--ui-font-xs-tight);
    -webkit-line-clamp: 1;
  }

  .dialog-popup-source-documents-source-action {
    width: 24px;
    height: 24px;
  }

  .dialog-popup-source-documents-source-text {
    padding: 0.75rem;
    font-size: var(--ui-font-xs-plus);
    max-height: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DialogPopup/DialogPopupSourceDocuments/DialogPopupSourceDocuments.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qFAAqF;EACrF,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kCAAkC;IAClC,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB;EACnB;AACF","sourcesContent":[".dialog-popup-source-documents-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: 0.5rem 0;\n}\n\n.dialog-popup-source-documents-section-label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.dialog-popup-source-documents-section-title {\n  font-size: var(--ui-font-md);\n  font-weight: 600;\n  color: #374151;\n}\n\n.dialog-popup-source-documents-section-description {\n  font-size: var(--ui-font-sm);\n  color: #6b7280;\n  line-height: 1.4;\n}\n\n.dialog-popup-source-documents-section-description-link {\n  color: var(--primary-color);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.dialog-popup-source-documents-section-description-link:hover {\n  text-decoration: underline;\n}\n\n.dialog-popup-source-documents-section-description-link-disabled {\n  color: #94a3b8;\n  cursor: default;\n  text-decoration: none;\n}\n\n.dialog-popup-source-documents-section-description-tag {\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.dialog-popup-source-documents-section-description-tag.clamped {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.dialog-popup-source-documents-section-description-tag.expanded {\n  display: block;\n}\n\n.dialog-popup-source-documents-section-description-toggle {\n  width: fit-content;\n  padding: 0;\n  margin: -0.05rem 0 0;\n  border: none;\n  background: transparent;\n  font-size: var(--ui-font-sm);\n  font-weight: 600;\n  color: var(--primary-color);\n  cursor: pointer;\n}\n\n.dialog-popup-source-documents-section-description-toggle:hover {\n  text-decoration: underline;\n}\n\n.dialog-popup-source-documents-sources {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-bottom: 0.5rem;\n}\n\n.dialog-popup-source-documents-source-card {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow: hidden;\n  transition: all 0.2s ease;\n}\n\n.dialog-popup-source-documents-source-card:hover {\n  border-color: #cbd5e1;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.dialog-popup-source-documents-source-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.875rem;\n  gap: 0.625rem;\n}\n\n.dialog-popup-source-documents-source-info {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.dialog-popup-source-documents-source-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  background: #e0e7ff;\n  color: #3730a3;\n  border-radius: 8px;\n  flex-shrink: 0;\n}\n\n.dialog-popup-source-documents-source-icon-file-type {\n  background: transparent;\n  color: inherit;\n}\n\n.dialog-popup-source-documents-source-icon-image {\n  width: 20px;\n  height: 20px;\n  object-fit: contain;\n}\n\n.dialog-popup-source-documents-source-details {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.dialog-popup-source-documents-source-name {\n  font-size: var(--ui-font-sm-plus);\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 0.125rem;\n  word-break: break-all;\n  line-height: 1.35;\n}\n\n.dialog-popup-source-documents-source-preview {\n  font-size: var(--ui-font-xs);\n  color: #64748b;\n  line-height: 1.35;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.dialog-popup-source-documents-source-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  flex-shrink: 0;\n}\n\n.dialog-popup-source-documents-source-action {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  color: #64748b;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.dialog-popup-source-documents-source-action:hover {\n  background: #e2e8f0;\n  color: #374151;\n}\n\n.dialog-popup-source-documents-source-content {\n  border-top: 1px solid #e2e8f0;\n  background: white;\n  animation: slideDown 0.2s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    max-height: 0;\n  }\n  to {\n    opacity: 1;\n    max-height: 300px;\n  }\n}\n\n.dialog-popup-source-documents-source-text {\n  padding: 1rem;\n  margin: 0;\n  font-family: \"SF Mono\", \"Monaco\", \"Inconsolata\", \"Roboto Mono\", \"Consolas\", monospace;\n  font-size: var(--ui-font-sm);\n  line-height: 1.5;\n  color: #374151;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  background: none;\n  border: none;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.dialog-popup-source-documents-source-text::-webkit-scrollbar {\n  width: 6px;\n}\n\n.dialog-popup-source-documents-source-text::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n.dialog-popup-source-documents-source-text::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n.dialog-popup-source-documents-source-text::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n@media (max-width: 550px) {\n  .dialog-popup-source-documents-source-header {\n    padding: 0.75rem;\n    gap: 0.5rem;\n  }\n\n  .dialog-popup-source-documents-source-info {\n    gap: 0.5rem;\n  }\n\n  .dialog-popup-source-documents-source-icon {\n    width: 24px;\n    height: 24px;\n  }\n\n  .dialog-popup-source-documents-source-icon-image {\n    width: 18px;\n    height: 18px;\n  }\n\n  .dialog-popup-source-documents-source-name {\n    font-size: var(--ui-font-sm);\n  }\n\n  .dialog-popup-source-documents-source-preview {\n    font-size: var(--ui-font-xs-tight);\n    -webkit-line-clamp: 1;\n  }\n\n  .dialog-popup-source-documents-source-action {\n    width: 24px;\n    height: 24px;\n  }\n\n  .dialog-popup-source-documents-source-text {\n    padding: 0.75rem;\n    font-size: var(--ui-font-xs-plus);\n    max-height: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
